import type { GalleryImage } from '../types/showcase';

const up = 'https://buildersshowcaseofhomes.com/wp-content/uploads/2026/01';
const page = (file: string, n: number): GalleryImage => ({
  src: `${up}/2026-Showcase-of-Homes-Magazine_Page_${file}-791x1024.jpg`,
  alt: `Showcase Magazine page ${n}`,
  caption: `Page ${n}`,
});

export const showcaseCover = `${up}/Showcase-Cover-1.jpg`;

export const tourMap: GalleryImage = {
  src: `${up}/Map-8.0.jpg`,
  alt: '2026 Builders’ Showcase of Homes tour map of Cape Coral',
  caption: 'Official tour map',
};

export const mapLegends: GalleryImage[] = [
  { src: `${up}/Showcase-Entry-Legend-1.jpg`, alt: 'Showcase entry legend, part 1', caption: 'Entry legend — part 1' },
  { src: `${up}/Page-2-Legend.jpg`, alt: 'Showcase entry legend, part 2', caption: 'Entry legend — part 2' },
];

export const covers: GalleryImage[] = [
  { src: `${up}/2026-Showcase-of-Homes-Magazine_Page_01-2-791x1024.jpg`, alt: 'Magazine cover for weekend one', caption: 'Weekend 1 cover' },
  { src: `${up}/2026-Showcase-of-Homes-Magazine_Page_56-1-791x1024.jpg`, alt: 'Magazine cover for weekend two', caption: 'Weekend 2 cover' },
  { src: `${up}/2026-Showcase-of-Homes-Magazine_Page_57-1-791x1024.jpg`, alt: 'Magazine cover for weekend three', caption: 'Weekend 3 cover' },
];

export const magazinePages: GalleryImage[] = [
  page('01-1', 1), page('02-1', 2), page('03-1', 3), page('05-1', 5), page('08', 8), page('09', 9),
  page('10', 10), page('12', 12), page('13', 13), page('14', 14), page('15', 15), page('16', 16),
  page('17', 17), page('18', 18), page('19', 19), page('20', 20), page('21', 21), page('22', 22),
  page('23', 23), page('24', 24), page('25', 25), page('26', 26), page('27', 27), page('28', 28),
  page('29', 29), page('30', 30), page('31', 31), page('32', 32), page('33', 33), page('34', 34),
  page('35', 35), page('36', 36), page('37', 37), page('38', 38), page('39', 39), page('40', 40),
  page('41', 41), page('42', 42), page('43', 43), page('44', 44), page('45', 45), page('46', 46),
  page('47', 47), page('48', 48), page('49', 49), page('50', 50), page('51', 51), page('52', 52),
  page('53', 53), page('54', 54), page('56', 56), page('57', 57),
];
